import React, { Component } from 'react';
import './TextPanel.css';
import CustomButton from '../subComponents/CustomButton';
import { restart } from '../../redux';
import { connect } from 'react-redux';

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  restart: () => dispatch(restart())
});

export default connect(mapStateToProps, mapDispatchToProps)(class TextPanel extends Component {

  onBackClick = () => {
    this.props.restart();
  }

  onReturnClick = () => {
    // this.props.onReturnClick();
  }

  render() {
    return (
      <div className={'TextPanel'}>
        {this.props.text}
        <br />
        {this.props.showNewBooking && this.props.showNewBooking !== '' && 'Your new booking code: ' + this.props.showNewBooking}
        <br />
        {this.props.showReturn && <div><a href='https://www.ctrlv.ca/' style={{ textDecoration: 'inherit', color: 'inherit', cursor: 'auto' }}><CustomButton
          text={'RETURN TO CTRL V'}
          icon={'arrow_back'}
          onClick={this.onReturnClick}
          disabled={false}
        /></a></div>}
        {this.props.showBack && this.props.showBack !== '' && <div><CustomButton
          text={this.props.showBack}
          icon={'arrow_back'}
          onClick={this.onBackClick}
          disabled={false}
        /></div>}
      </div>
    );
  }
});
